import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const userLogin = createAsyncThunk('auth/userLogin',
  async ({email, password, cb}: {email: string, password: string, cb?: Function}) => {
    const url = 'v1/auth/login'
    const response: AxiosResponse<{access_token: string}> = await instance.post(url, { email, password })
    window.localStorage.setItem('access_token', response.data.access_token)
    if (cb) {
      cb(response.data)
    }
    return response.data
  })

export const userLogout = createAsyncThunk('auth/userLogout',
  async ({cb}: {cb?: Function}) => {
    const url = 'v1/auth/logout'
    instance.delete(url).then(value => {
      if (cb) {
        cb(value.data)
      }
      return value.data
    })
    
    window.localStorage.removeItem('access_token')
    window.localStorage.removeItem('menu_list')
  })
